<template>
  <div id="userLayout" :class="['user-layout-wrapper']">
    <div class="container" :style="{background: data[nowIndex].color}">
      <div class="top">
        <div class="header">
          <!-- <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/logo.png" class="logo" alt="logo">
          <span class="title">灵点</span> -->
          <img class="logo" src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60daada610992/125307583.png" alt="">
        </div>
      </div>
      <div class="content">
        <img :src="data[nowIndex].img" alt="">
        <div class="headline" :style="{color: data[nowIndex].fontColor}">{{ data[nowIndex].title }}</div>
        <div class="desc" :style="{color: data[nowIndex].fontColor}">{{ data[nowIndex].desc }}</div>
        <div class="button">
          <div class="previous" @click="pre" :style="{background: backgroundColorPre}">
            <img src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60dc3157983ca/733332095.png" alt="">
          </div>
          <div class="next" @click="next"  :style="{background: backgroundColorNext}"> 
            <img src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60dc3157a68c9/449548413.png" alt="">
          </div>
        </div>
      </div>
      <div class="register">
        <div class="noWrite" v-if='!canWrite'>
          <div @click="canWrite = true">免费试用</div>
        </div>
        <div class="write" v-else>
          <div class="list">
            <el-input class="inputElement" maxlength="20" v-model="value1" placeholder="请输入学校名称"></el-input>
          </div>
          <div class="list">
            <el-input class="inputElement" maxlength="5" v-model="value2" placeholder="请填写联系人姓名"></el-input>
          </div>
          <div class="list">
            <el-input class="inputElement" maxlength="11" v-model="value3" placeholder="请输入手机号码"></el-input>
          </div>
          <div class="list verifiableCode">
            <el-input class="inputElement" v-model="value4" placeholder="图片验证码"></el-input>
            <img @click="setCode" :src="codeSrc" alt="">
          </div>
          <div class="submit" :class="[canSubmit ? 'canSubmit' : '']" @click="submit">立即申请试用</div>
          <div class="success" v-if="showSuccess">
            <div class="detail">
              <div class="desc">
                <span>已收到您的申请信息，请保持电话畅通，工作人员会在</span>
                <span class="emphasis">3</span>
                <span>个工作日内联系您！</span>
              </div>
              <div class="confirm" @click="showSuccess = false">确定</div>
            </div>
          </div>
          <div class="message" v-if="showMessage">{{ message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jiangCollect } from "@/services/api";

export default {
  name: 'UserLayout',
  data() {
    return {
      data: [{
        color: '#E0E6FE',
        img: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60daada688373/349621217.png',
        fontColor: '#1652EC',
        title: '灵活的教学模式',
        desc: '教师学生控播、双人、自由模式、自主学习'
      }, {
        color: '#DAF2FF',
        img: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60dabd346b7c9/108042302.png',
        fontColor: '#1E88E5',
        title: '丰富的课件资源',
        desc: '机械专业拥有工训等4大类，超300个3D模型课件'
      }, {
        color: '#E0E6FE',
        img: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60dabde8dc11f/824416532.png',
        fontColor: '#324CDE',
        title: '多终端设备支持',
        desc: 'PC、大屏、燧光MR、未来感知、HTC vive、安卓'
      }, {
        color: '#DAF2FF',
        img: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60dabe5caf916/822419249.png',
        fontColor: '#1E88E5',
        title: '多维度数据分析',
        desc: '按学科设备等多维度，统计教学数据'
      } ],
      nowIndex: 0,
      canWrite: false,
      value1: '',
      value2: '',
      value3: '',
      value4: '',
      showSuccess: false,
      codeSrc: '/api/apply/captcha',
      message: '',
      showMessage: false
    }
  },
  computed: {
    backgroundColorPre() {
      if (this.nowIndex === 0) {
        return '#B6C7FA'
      } else if (this.nowIndex === 1) {
        return '#86C2F4'
      } else if (this.nowIndex === 2) {
        return '#A2AEF2'
      } else if (this.nowIndex === 3) {
        return '#86C2F4'
      } else {
        return false
      }
    },
    backgroundColorNext() {
      if (this.nowIndex === 0) {
        return '#A2AEF2'
      } else if (this.nowIndex === 1) {
        return '#86C2F4'
      } else if (this.nowIndex === 2) {
        return '#A2AEF2'
      } else if (this.nowIndex === 3) {
        return '#B2DBF9'
      } else {
        return false
      }
    },
    canSubmit() {
      return !!(this.value1 && this.value2 && this.value3 && (this.value4.length === 4))
    }
  },
  mounted () { },
  methods: {
    submit() {
      const data = {
        name: this.value1,
        uname: this.value2,
        phone: this.value3,
        captcha: this.value4
      }
      if (!this.canSubmit) {
        return
      }
      this.value4 = ''
      jiangCollect(data).then(res => {
        this.setCode()
        if (res.s === 200) {
          this.value1 = ''
          this.value2 = ''
          this.value3 = ''
          this.showSuccess = true
        } else {
          this.message = res.msg
          this.showMessage = true
          setTimeout(() => {
            this.showMessage = false
          }, 1000);
        }
      })
    },
    setCode () {
      this.codeSrc = `/api/apply/captcha?${Date.now()}`
    },
    pre() {
      if (this.nowIndex === 0) {
        return
      } else {
        this.nowIndex = this.nowIndex - 1
      }
    },
    next() {
      if (this.nowIndex == 3) {
        return
      } else {
        this.nowIndex = this.nowIndex + 1
      }
    }
  },
  beforeDestroy () { }
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
    height: 100vh;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;
      background-size: 100%;
      position: relative;
      padding-top: 80px;
      display: flex;
      align-items: center;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 80px;
          display: flex;
          align-items: center;
          padding-left: 10vw;
          background: #fff;
          z-index: 100;
          box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.08);
          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 57px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            height: auto;
            font-size: 24px;
            font-weight: normal;
            color: #8FA1AE;
            line-height: 29px;
            position: relative;
          }
          .title::after{
            content: '';
            width: 1px;
            height: 17px;
            background: #E6EDF2;
            position: absolute;
            top: 5px;
            left: -8px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
.content{
  width: 40vw;
  max-width: 800px;
  margin-left: 10vw;
  > img{
    width: 100%;
  }
  .headline{
    font-size: 36px;
    font-weight: 600;
    line-height: 52px;
    letter-spacing: 2px;
    text-align: center;
  }
  .desc{
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: center;
    margin-top: 10px;
  }
  .button{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    > div{
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      color: #fff;
      line-height: 1;
      cursor: pointer;
      font-size: 12px;
      > img {
        width: 9px;
        height: 17px;
      }
    }
    .previous{
      margin-right: 27px;
    }
  }
}
.register{
  position: absolute;
  top: 0;
  right: 118px;
  display: flex;
  align-items: center;
  height: 100vh;
  .noWrite{
    width: 615px;
    height: 455px;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60daada64fda5/314536407.png);
    background-size: 100% 100%;
    > div{
      width: 440px;
      height: 73px;
      background: linear-gradient(90deg, #F1F6FB 0%, #F1F6FE 100%);
      box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.06), 0px 0px 21px -10px #3972D1;
      border-radius: 37px;
      margin: 0 auto;
      margin-top: 290px;
      font-size: 30px;
      font-weight: 500;
      color: #5F88EB;
      line-height: 76px;
      text-align: center;
      text-shadow: 0px 0px 40px rgba(0, 0, 0, 0.06);
      cursor: pointer;
    }
  }
  .write{
    width: 615px;
    height: 713px;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60dab4b49ce07/775806588.png);
    background-size: 100% 100%;
    padding-top: 160px;
    box-sizing: border-box;
    position: relative;
    .list{
      width: 425px;
      height: 62px;
      margin: 0 auto;
      margin-bottom: 28px;
      .inputElement{
        height: 100%;
        /deep/ .el-input__inner{
          background: #FFFFFF;
          border-radius: 34px;
          width: 100%;
          height: 100%;
          padding: 0 43px;
          font-size: 18px;
          font-weight: 400;
          color: #0D2340;
        }
      }
    }
    .verifiableCode{
      display: flex;
      justify-content: space-between;
      .inputElement{
        width: 298px;
      }
      img{
        width: 106px;
        height: 53px;
      }
    }
    .submit{
      width: 430px;
      height: 73px;
      background: #FFFFFF;
      box-shadow: 0px 0px 17px -4px #398BD1;
      border-radius: 37px;
      opacity: 0.6;
      margin: 0 auto;
      margin-top: 50px;
      font-size: 22px;
      font-weight: 500;
      color: #88B1F9;
      line-height: 73px;
      text-align: center;
    }
    .canSubmit{
      opacity: 1;
      cursor: pointer;
      color: #386EF1;
    }
    .success{
      position: absolute;
      top: 40px;
      left: 40px;
      width: 535px;
      height: 632px;
      background: rgba(255, 255, 255, .49);
      box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.06);
      border-radius: 26px;
      display: flex;
      justify-content: center;
      align-items: center;
      .detail{
        width: 448px;
        height: 257px;
        background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60dacdfe1be62/500617524.png);
        background-size: 100% 100%;
        margin-top: 24px;
        .desc{
          line-height: 42px;
          width: 360px;
          text-align: center;
          margin: 0 auto;
          margin-top: 57px;
          span{
            font-size: 20px;
            font-weight: 400;
            color: #FFFFFF;
          }
          .emphasis{
            font-size: 26px;
            font-weight: 500;
            padding: 0 4px;
          }
        }
        .confirm{
          width: 152px;
          height: 43px;
          background: #FFFFFF;
          border-radius: 37px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-weight: 400;
          color: #386EF1;
          margin: 0 auto;
          margin-top: 38px;
          cursor: pointer;
        }
      }
    }
    .message{
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      height: 62px;
      margin: auto;
      width: fit-content;
      background: rgba(0, 0, 0, 0.81);
      border-radius: 6px;
      font-size: 20px;
      font-weight: 400;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      padding: 0 34px;
    }
  }
}
</style>
<style>
  #newBridge{
    display: none !important;
  }
</style>
<style>
  html[lang=zh-CN]{
    font-size: 260px !important;
  }
</style>
